import { Text } from '@droplet-tech-code/core-elements/module/ui/Text';
import { View } from '@droplet-tech-code/core-elements/module/ui/View';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

export const PurchaseSupportRequestsListHeader = ({
  numberOfRequests,
  purchaseId,
}: {
  numberOfRequests?: string;
  purchaseId: string;
}) => {
  return (
    <PageHeader
      title={translate('supportRequests.purchaseSupportRequests')}
      Subtitle={Subtitle({ purchaseId, numberOfRequests })}
      withBack={isNativeMobile}
    />
  );
};

const Subtitle = ({
  purchaseId,
  numberOfRequests,
}: {
  purchaseId: string;
  numberOfRequests?: string;
}) => {
  return (
    <View pt="1">
      <Text.Small color="monochrome-mid">{`${purchaseId} - ${
        numberOfRequests || ''
      } ${translate('supportRequests.requests')}`}</Text.Small>
    </View>
  );
};
